import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const FontSizeArray = [
  {
    name: 'Standardwert',
    value: null,
  },
  {
    name: "12",
    value: 12,
  },
  {
    name: "14",
    value: 14,
  },
  {
    name: "16",
    value: 16,
  },
  {
    name: "18",
    value: 18,
  },
  {
    name: "20",
    value: 20,
  }
];

export const KeymapStyleSchema = BaseSchema.extend({
  color: z.string().max(255).nullable().default(null),
  fontSize: z.number().nullable().default(null),
  rowDistance: z.number().nullable().default(null),
  columnDistance: z.number().nullable().default(null),
  indexWidth: z.number().nullable().default(null),
  keymap: z.string().max(255).optional()
});

export type KeymapStyle = z.infer<typeof KeymapStyleSchema>;

export const KeymapStyleEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: KeymapStyleSchema,
});

export type KeymapStyleEntityQueryResult = z.infer<typeof KeymapStyleEntityQueryResultSchema>;
